module.exports = __webpack_public_path__ + "img/regPeting.7600221d.png";